var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center cont-boton--pse",on:{"click":_vm.openPage}},[_c('img',{staticClass:"icono-pse--boton",attrs:{"src":require("../assets/img/logo-pse.png"),"alt":""}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cont-btn-realizarpago",attrs:{"color":"primary","x-small":""}},[_vm._v("Realizar "),_c('br'),_vm._v(" pagos")])
}]

export { render, staticRenderFns }